import { EventEmitter, Directive, ElementRef, Input, Output, NgModule } from '@angular/core';
import createFocusTrap from 'focus-trap';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-focus-trap.directive.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class NgxFocusTrapDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.escapeDeactivates = true;
        this.clickOutsideDeactivates = false;
        this.returnFocusOnDeactivate = true;
        this.initActivated = true;
        this.activate = new EventEmitter();
        this.deactivate = new EventEmitter();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const options = {
            onActivate: (/**
             * @return {?}
             */
            () => this.activate.emit()),
            onDeactivate: (/**
             * @return {?}
             */
            () => this.deactivate.emit()),
            escapeDeactivates: this.escapeDeactivates,
            clickOutsideDeactivates: this.clickOutsideDeactivates,
            returnFocusOnDeactivate: this.returnFocusOnDeactivate,
            initialFocus: this.initialFocus,
            fallbackFocus: this.fallbackFocus
        };
        /** @type {?} */
        const focusTrap = this.focusTrap = createFocusTrap(this.elementRef.nativeElement, options);
        if (this.initActivated)
            focusTrap.activate();
    }
    /**
     * @return {?}
     */
    activateFocusTrap() {
        this.focusTrap.activate();
    }
    /**
     * @return {?}
     */
    deactivateFocusTrap() {
        this.focusTrap.deactivate();
    }
    /**
     * @return {?}
     */
    pause() {
        this.focusTrap.pause();
    }
    /**
     * @return {?}
     */
    unpause() {
        this.focusTrap.unpause();
    }
}
NgxFocusTrapDirective.ɵfac = function NgxFocusTrapDirective_Factory(t) { return new (t || NgxFocusTrapDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxFocusTrapDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxFocusTrapDirective, selectors: [["", "ngxFocusTrap", ""]], inputs: { escapeDeactivates: "escapeDeactivates", clickOutsideDeactivates: "clickOutsideDeactivates", returnFocusOnDeactivate: "returnFocusOnDeactivate", initActivated: "initActivated", initialFocus: "initialFocus", fallbackFocus: "fallbackFocus" }, outputs: { activate: "activate", deactivate: "deactivate" }, exportAs: ["ngxFocusTrap"] });
/** @nocollapse */
NgxFocusTrapDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxFocusTrapDirective.propDecorators = {
    escapeDeactivates: [{ type: Input }],
    clickOutsideDeactivates: [{ type: Input }],
    returnFocusOnDeactivate: [{ type: Input }],
    initialFocus: [{ type: Input }],
    fallbackFocus: [{ type: Input }],
    initActivated: [{ type: Input }],
    activate: [{ type: Output }],
    deactivate: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFocusTrapDirective, [{
        type: Directive,
        args: [{
                selector: '[ngxFocusTrap]',
                exportAs: 'ngxFocusTrap'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { escapeDeactivates: [{
            type: Input
        }], clickOutsideDeactivates: [{
            type: Input
        }], returnFocusOnDeactivate: [{
            type: Input
        }], initActivated: [{
            type: Input
        }], activate: [{
            type: Output
        }], deactivate: [{
            type: Output
        }], initialFocus: [{
            type: Input
        }], fallbackFocus: [{
            type: Input
        }] }); })();
if (false) {
    /** @type {?} */
    NgxFocusTrapDirective.prototype.escapeDeactivates;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.clickOutsideDeactivates;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.returnFocusOnDeactivate;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.initialFocus;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.fallbackFocus;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.initActivated;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.activate;
    /** @type {?} */
    NgxFocusTrapDirective.prototype.deactivate;
    /**
     * @type {?}
     * @private
     */
    NgxFocusTrapDirective.prototype.focusTrap;
    /**
     * @type {?}
     * @private
     */
    NgxFocusTrapDirective.prototype.elementRef;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/ngx-focus-trap.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class NgxFocusTrapModule {
}
NgxFocusTrapModule.ɵfac = function NgxFocusTrapModule_Factory(t) { return new (t || NgxFocusTrapModule)(); };
NgxFocusTrapModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxFocusTrapModule });
NgxFocusTrapModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxFocusTrapModule, [{
        type: NgModule,
        args: [{
                declarations: [NgxFocusTrapDirective],
                exports: [NgxFocusTrapDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxFocusTrapModule, { declarations: [NgxFocusTrapDirective], exports: [NgxFocusTrapDirective] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: ngx-focus-trap.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NgxFocusTrapDirective, NgxFocusTrapModule };

